import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

export default function ActionDialogShell({
    open,
    onClose,
    title,
    headerBgColor,
    headerTextColor,
    children,
    actions,
    dialogProps,
}) {
    return (
        <Dialog open={open} onClose={onClose} {...dialogProps}>
            <DialogTitle
                sx={
                    headerBgColor
                        ? {
                            bgcolor: headerBgColor,
                            color: headerTextColor,
                            pb: 1.5,
                        }
                        : undefined
                }
            >
                {title}
            </DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions>{actions}</DialogActions>
        </Dialog>
    );
}
